import { Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/lazy';

@Injectable({
  providedIn: 'root',
})
export class ToastService {

  constructor(private toastController: ToastController) {
  }

  public async presentToast(message: string, color: string = 'primary') {
    const toast = await this.toastController.create({
      message,
      duration: 4000,
      color,
      position: 'top',
    });
    toast.present();
  }

}
